import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export const httpLoaderFactory: (http: HttpClient) => TranslateLoader = (http: HttpClient) => {
  return new TranslateHttpLoader(http, 'i18n/', '.json');
};
